import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';

import React, { useState, useEffect, useRef, useContext } from 'react';

/* ################ IMPORTS OF PRIMEREACT ################*/
import { DataTable } from 'primereact/datatable';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { useNavigate, Link } from 'react-router-dom';


import '../../css/ListBotTemplates.css';

import TemplateIntegration from '../../integrations/TemplateIntegration';
import ConfigIntegration from '../../integrations/ConfigIntegration';
import { EnvContext } from '../Context/EnvProvider';
import {
    environmentOptions,
    getEnvironmentByKey,
} from '../../environments';

import { useAuth0 } from "@auth0/auth0-react";
import { useAuthToken } from '../../hooks/useAuthToken';

const templateIntegration = new TemplateIntegration();
const configIntegration = new ConfigIntegration();

const ListBotTemplates = () => {

    const [botTemplates, setBotTemplates] = useState(null);
    const [expandedRows, setExpandedRows] = useState(null);
    const [copyTemplateDialog, setCopyTemplateDialog] = useState(false);
    const [botTemplate, setBotTemplate] = useState();
    const [globalFilter, setGlobalFilter] = useState(null);
    const [loading, setLoading] = useState(true);
    const [reload, setReload] = useState(false);
    const [deleteTemplateDialog, setDeleteTemplateDialog] = useState(null);
    const [localEnvironmentKey, setLocalEnvironmentKey] = useState(null);
    const [newNameTemplate, setNewNameTemplate] = useState();
    const toast = useRef(null);
    const { user, isAuthenticated } = useAuth0();
    const { getAccessToken } = useAuthToken();

    const { environment, environmentKey } = useContext(EnvContext);
    const localEnvironment = getEnvironmentByKey(localEnvironmentKey || environmentKey);

    const navigate = useNavigate();

    useEffect(() => {
        if (!isAuthenticated) {
            return;
        }

        getAccessToken()
            .then((accessToken) =>
                templateIntegration.listTemplates(environment.listBots, user.email, accessToken)
            )
            .then(data => {
                setBotTemplates(data);
                setLoading(false);
                setReload(false);
            })
            .catch(error => {
                console.error('[ListBotTemplates] Failed to load templates:', error);
                setBotTemplates([]);
                setLoading(false);
                setReload(false);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Não foi possível carregar os templates. Verifique a API e tente novamente.',
                    life: 5000,
                });
            });
    }, [environment, getAccessToken, isAuthenticated, reload, user.email]);

    const hideCopyBotTemplateDialog = () => {
        setCopyTemplateDialog(false);
    }

    const openCopyBotTemplate = (botTemplate) => {
        setBotTemplate(botTemplate);
        setNewNameTemplate(botTemplate.nameTemplate);
        setLocalEnvironmentKey(environmentKey);
        setCopyTemplateDialog(true);
    }
    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button
                    icon="pi pi-trash"
                    className="p-button-rounded p-button-danger p-mr-2"
                    onClick={() => confirmDeleteTemplate(rowData)}
                />
            </React.Fragment>
        );
    };
    const confirmDeleteTemplate = (botTemplate) => {
        setBotTemplate(botTemplate);
        setDeleteTemplateDialog(true);
    }
    const hidedeleteTemplateDialog = () => {
        setDeleteTemplateDialog(false);
    }
    const deleteTemplate = async () => {
        const authToken = await getAccessToken();
        
        templateIntegration.deleteTemplate(environment.botApi, botTemplate.id, authToken)
            .then(json => {
                toast.current.show({ severity: 'success', summary: 'Sucesso!', detail: 'Template Excluido!', life: 3000 });
                setDeleteTemplateDialog(false);
                setReload(true);
            }).catch(error => {
                console.error(error);
                toast.current.show({ severity: 'error', summary: 'Erro!', detail: 'Erro ao deletar o Template.', life: 5000 });
            });
    }
    const deleteTemplateDialogFooter = (
        <React.Fragment>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={hidedeleteTemplateDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={deleteTemplate} />
        </React.Fragment>
    );

    const copyBotTemplate = async () => {
        const authToken = await getAccessToken();

        configIntegration.getConfig(environment.botApi, botTemplate.id, authToken).then(templateConfig => {
            botTemplate.nameTemplate = newNameTemplate;
            botTemplate.id = null;
            templateIntegration.saveTemplate(localEnvironment.botApi, botTemplate, authToken)
                .then(newTemplate => {
                    templateConfig.id = newTemplate.id;
                    configIntegration.saveConfig(localEnvironment.botApi, newTemplate.id, templateConfig, authToken)
                        .then(newConfig => {
                            toast.current.show({ severity: 'success', summary: 'Sucesso!', detail: 'Novo template ' + newTemplate.nameTemplate + ' criado com sucesso".', life: 5000 });
                            hideCopyBotTemplateDialog();
                        }).catch(error => {
                            console.error(error);
                            toast.current.show({ severity: 'error', summary: 'Erro!', detail: 'Erro ao salvar ao salvar as novas configurações.', life: 5000 });
                        });
                    setReload(true);

                }).catch(error => {
                    console.error(error);
                    toast.current.show({ severity: 'error', summary: 'Erro!', detail: 'Erro criar novo template.', life: 5000 });
                });
        });
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Novo" icon="pi pi-plus" className="p-button-success p-mr-2" onClick={() => navigate('/BotTemplate')} />
            </React.Fragment>
        )
    }

    const header = (
        <div className="table-header">
            <h5 className="p-mx-0 p-my-1">Procurar Templates</h5>
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Procurar..." />
            </span>
        </div>
    );
    const deleteBotTemplateDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideCopyBotTemplateDialog} />
            <Button label="Copiar" icon="pi pi-copy" className="p-button-text" onClick={copyBotTemplate} />
        </React.Fragment>
    );
    const rowExpansionTemplate = (rowData) => {
        return (
            <div className="orders-subtable">
                <div className="p-fluid p-grid">
                    <div className="p-col">
                        <Button
                            style={{ height: '100%' }}
                            icon="pi pi-pencil"
                            label="EDITAR"
                            className="p-button-rounded p-button-secondary"
                            onClick={() =>
                                navigate('/BotTemplate?templateId=' + rowData.id)
                            }
                        />
                    </div>
                    <div className="p-col">
                        <Button
                            style={{ height: '100%' }}
                            icon="pi pi-cog"
                            label="CONFIGURAÇÕES"
                            className="p-button-rounded p-button-secondary"
                            onClick={() =>
                                navigate('/AdvancedConfig?templateId=' + rowData.id)
                            }
                        />
                    </div>
                    <div className="p-col">
                        <Button
                            style={{ height: '100%' }}
                            icon="pi pi-sitemap"
                            label="INSTANCIAS"
                            className="p-button-rounded p-button-secondary"
                            onClick={() => navigate('/ListBotInstances?templateId=' + rowData.id)}
                        />
                    </div>
                    <div className="p-col">
                        <Button
                            style={{ height: '100%' }}
                            icon="pi pi-clone"
                            label="TIPOS DE DADOS"
                            className="p-button-rounded p-button-secondary"
                            onClick={() => navigate('/UserDataTypes?templateId=' + rowData.id)}
                        />
                    </div>
                    <div className="p-col">
                        <Button
                            style={{ height: '100%' }}
                            icon="pi pi-copy"
                            label="COPIAR TEMPLATE"
                            className="p-button-rounded p-button-secondary"
                            onClick={() =>
                                openCopyBotTemplate(rowData)
                            }
                        />
                    </div>
                    <div className="p-col">
                        <Button
                            style={{ height: '100%' }}
                            icon="pi pi-copy"
                            label="ERROS"
                            className="p-button-rounded p-button-secondary"
                            onClick={() => navigate('/Errors?templateId=' + rowData.id)}
                        />
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="listTemplate">
            <Toast ref={toast} />
            <div className="card">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li className="breadcrumb-item active">
                            <span>Lista de Templates</span>
                        </li>
                    </ol>
                </nav>
            </div>

            <div className="card">

                <Toolbar className="p-mb-4" left={leftToolbarTemplate}></Toolbar>
                <DataTable value={botTemplates}
                    expandedRows={expandedRows}
                    rowExpansionTemplate={rowExpansionTemplate}
                    onRowToggle={(e) => setExpandedRows(e.data)}
                    globalFilter={globalFilter} header={header} responsiveLayout="scroll"
                    loading={loading}
                    dataKey="id">
                    <Column expander style={{ width: '3em' }} />
                    <Column field="id" header="ID" sortable style={{ minWidth: '10rem' }}></Column>
                    <Column field="nameTemplate" header="Nome do Template" sortable style={{ minWidth: '25rem' }}></Column>
                    <Column field="businessLine" header="Tipo de Negócio" sortable style={{ minWidth: '8rem' }}></Column>
                    <Column field="templateLanguage" header="Linguagem" sortable style={{ minWidth: '5rem' }}></Column>
                    <Column header="Deletar Template" body={actionBodyTemplate} style={{ width: '5rem', textAlign: 'center' }}></Column>
                </DataTable>
            </div>

            <Dialog visible={copyTemplateDialog} style={{ width: '700px' }} header="Copiar Template" modal footer={deleteBotTemplateDialogFooter} onHide={hideCopyBotTemplateDialog}>
                <div className="confirmation-content">
                    <div>
                        {botTemplate && (
                            <span>
                                Copiar o template: <b>{botTemplate.nameTemplate}</b> do ambiente:{' '}
                                <b>{environmentKey}</b>
                            </span>
                        )}
                    </div>
                    <div>
                        <span style={{ marginRight: "10px" }}>
                            para o ambiente:
                        </span>
                        <Dropdown
                            style={{ width: "150px" }}
                            value={localEnvironmentKey || environmentKey}
                            options={environmentOptions}
                            optionLabel="label"
                            optionValue="key"
                            onChange={(e) => setLocalEnvironmentKey(e.value)}
                        />
                        <span style={{ marginRight: "10px", marginLeft: "10px" }}>
                            com o nome de:
                        </span>
                        <InputText value={newNameTemplate} onInput={(e) => setNewNameTemplate(e.target.value)} />
                    </div>
                </div>
            </Dialog>
            <Dialog visible={deleteTemplateDialog} style={{ width: '450px' }} header="Confirme" modal footer={deleteTemplateDialogFooter} onHide={hidedeleteTemplateDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                    {botTemplate && <span>Tem certeza de que deseja excluir o template: <b>{botTemplate.nameTemplate}</b>?</span>}
                </div>
            </Dialog>
        </div>
    );
}
export default ListBotTemplates;
